import { ProductAccountingCategoryUpdatePage } from '@/features/product-accounting-category/pages/ProductAccountingCategoryUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/admin/product-accounting-category/$id/update',
)({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_accounting_category.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductAccountingCategoryUpdatePage,
})